import React, {
    useEffect,
    useRef,
    useState
} from 'react'
import './player-list-container.styles.scss';

import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import ManagerPlayerView from './player-view.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';

import AddPlayer from './add-player.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { createAlias } from '@/utils/aliases';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import {
    ModalAlert,
    ModalConfirm
} from '@/components/modal/modal.component';
import { sortPlayers } from '@/utils/sortPlayers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBan,
    faDownload,
    faFilter,
    faFilterCircleXmark,
    faList,
    faPrint,
    faQrcode,
    faRefresh,
    faSignature,
    faUsers
} from '@fortawesome/free-solid-svg-icons';
import {
    membershipRestrictions,
    testMemberRestrictions
} from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import ResetData from './reset-data.component';
import CsvDownload from 'react-json-to-csv';
import { Mobile } from '@/utils/responsiveQueries';
import PlayerListMobile from './player-list-mobile.component';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import CategoryFilterModal from '../create-elements/components/category-filter-modal.component';
import { formatNumber } from '@/utils/formatNumber';
import { getPlayersFromPlayerDocs } from '@/utils/getDataFromDb';
import PlayerListDesktop from './player-list-desktop.component';
import useAnalytics from '@/utils/useAnalytics';

const PlayerListContainer = ({
    gameData,
    gameElements,
    playerList,
    gameStats,
    passcodes,
    teamMembers,
    role
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [sortedPlayers, setSortedPlayers] = useState([]);
    const [teams, setTeams] = useState([]);
    const [infoList, setInfoList] = useState([]);
    const [showAliases, setShowAliases] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState(null);
    const [viewHeight, setViewHeight] = useState('0px');
    const [showPlayerInfo, setShowPlayerInfo] = useState(false);
    const [currentSort, setCurrentSort] = useState(null);
    const [currentFilter, setCurrentFilter] = useState(null);
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const [passcodePlayers, setPasscodePlayers] = useState([]);
    const [showPlayerDrop, setShowPlayerDrop] = useState(false);
    const [playerCount, setPlayerCount] = useState(0);
    const [manager, setManager] = useState(false);
    const [chosenTeams, setChosenTeams] = useState([]);
    const [showTeamsFilterModal, setShowTeamsFilterModal] = useState(false);
    const [showInfoFilterModal, setShowInfoFilterModal] = useState(false);
    const [chosenInfo, setChosenInfo] = useState([]);
    const { trackEvent, trackException } = useAnalytics();
    const approveRef = useRef();
    const chosenTeamsRef = useRef([]);
    const chosenInfoRef = useRef([]);
    const navigate = useNavigate();
    const location = useLocation();
    let timeout;

    useEffect(() => {
        if (!role) return;
        if (role === 'owner' || role === 'manager') {
            setManager(true);
        }
    }, [role])

    useEffect(() => {
        timeout = setTimeout(() => {
            const chartContainer = document.getElementsByClassName('players-card');
            if (chartContainer.length > 0) {
                setViewHeight(`${chartContainer[0].clientHeight - 234}px`)
                // console.log(chartContainer[0].clientHeight);
            }
            if (screenSize === 'mobile' || screenSize === 'tablet') {
                setViewHeight('250px');
            }
        }, 500);

        return () => {
            if (timeout) clearTimeout(timeout);
        }
    }, [location])

    useEffect(() => {
        if (!playerList) return;
        search();
    }, [chosenInfo, chosenTeams, playerList, location])

    useEffect(() => {
        if (!playerList) { return; }
        // console.log(playerList);
        setPasscodePlayers(Object.values(playerList).filter(p => p.enroll_method === 'upload'));
        // console.log(playerList);
        // console.log(currentSort);
        // console.log(currentFilter);
        sortTable()
        const sortedPlayers = sortPlayers({
            'playerList': playerList,
            'sortBy': 'name',
            'filter': 'players'
        })
        setPlayerCount(sortedPlayers.length);
        setTeams(
            Object.values(playerList).filter(p => p.team)
        )
        setInfoList(
            [...new Set(Object.values(playerList)
                .filter(p => p.info)
                .map(p => p.info))
            ]
        )
    }, [playerList, currentFilter, currentSort, showAliases])

    function checkMembership(e) {
        const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'create': true });
        // console.log(res);
        if (res.disabled && res.disabledReason.includes('players')) {
            const planRest = membershipRestrictions[membership.membership];
            const message = `While using the ${planRest.title}, you are only able to have ${planRest.playerCount} active Players/Teams per game.`;
            setShowUpgradeModal(message);
            return;
        }
        navigate('add');
    }

    function search() {
        let text;
        const searchInput = document.getElementById('player-search-input');
        if (searchInput) {
            text = searchInput.value;
        }
        let filteredList = [];
        if (chosenTeams.length > 0) {
            for (let teamId of chosenTeams) {
                if (!teamMembers || !teamMembers[teamId]) continue;
                const teamList = teamMembers[teamId];
                if (!teamList || !teamList.members) continue;
                for (let playerId of teamList.members) {
                    if (!playerList[playerId]) continue;
                    filteredList.push(playerList[playerId])
                }
            }
        } else {
            filteredList = Object.values(playerList);
        }
        if (chosenInfo.length > 0) {
            filteredList = filteredList
                .filter(p => chosenInfo.includes(p.info))
        }
        const sortedFilteredPlayers = sortPlayers({
            'playerList': filteredList,
            'filter': 'players'
        })
        if (!text) {
            setSortedPlayers([...sortedFilteredPlayers]);
            return;
        }
        const searchedPlayers = sortedFilteredPlayers
            .filter(t => (
                t.fName.toLowerCase().includes(text.toLowerCase()) ||
                (t.lName && t.lName.toLowerCase().includes(text.toLowerCase())) ||
                t.displayName.toLowerCase().includes(text.toLowerCase())
            ))
        setSortedPlayers([...searchedPlayers]);

    }

    function chooseTeam(id) {
        if (!chosenTeamsRef.current) chosenTeamsRef.current = [];
        const tempTeams = [...chosenTeamsRef.current];
        if (tempTeams.includes(id)) {
            tempTeams.splice(tempTeams.indexOf(id), 1)
        } else {
            tempTeams.push(id);
        }
        chosenTeamsRef.current = [...tempTeams];
        setChosenTeams(chosenTeamsRef.current);

    }

    function chooseInfo(id) {
        if (!chosenInfoRef.current) chosenInfoRef.current = [];
        const tempInfo = [...chosenInfoRef.current];
        if (tempInfo.includes(id)) {
            tempInfo.splice(tempInfo.indexOf(id), 1)
        } else {
            tempInfo.push(id);
        }
        chosenInfoRef.current = [...tempInfo];
        setChosenInfo(chosenInfoRef.current);
    }

    function deselectAll() {
        chosenInfoRef.current = [];
        setChosenInfo([]);
        chosenTeamsRef.current = [];
        setChosenTeams([]);
    }

    function sortTable() {
        const sortBy = currentSort ? currentSort : showAliases ? 'alias' : 'name';
        let playersToDisplay = [];
        if (currentFilter) {
            const playerArr = Object.values(playerList).filter(p => p.info === currentFilter);
            playersToDisplay = sortPlayers({
                'playerList': playerArr,
                'sortBy': sortBy,
                'filter': 'players'
            });
        } else {
            playersToDisplay = sortPlayers({
                'playerList': playerList,
                'sortBy': sortBy,
                'filter': 'players'
            });
        }
        setSortedPlayers([...playersToDisplay]);
    }

    function clearFilter() {
        setCurrentFilter(null);
    }

    function printLogins() {
        window.open(`/printlogins/${gameData.path}`, '_new')
    }

    function printQrCodes() {
        window.open(`/printqrcodes/${gameData.path}`, '_new')
    }

    async function newAliases() {
        if (location.pathname.includes('/preview/manager/')) {
            setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
            return;
        }
        setConfirmMessage(`Are you sure you want to change all of the players' Aliases? This action cannot be undone.`)
        approveRef.current = () => {
            continueNewAliases();
        }

        async function continueNewAliases() {
            let playerArr
            for (let p of Object.values(playerList).filter(p => !p.group)) {
                playerArr.push({
                    "playerId": p.playerId,
                    "alias": createAlias(),
                })
            }
            console.log(playerArr);
            const res = await UseCloudFunction(
                'saveUpdatedPlayerList',
                {
                    'appId': userProfile.appId,
                    'gameId': gameData.gameId,
                    'playerArr': playerArr,
                    'action': 'Player Alias Reset'
                }
            )
            console.log(res);
            if (res.error) {
                setAlertMessage(`Something went wrong. Try again later. (Error: ${res.error})`);
                trackException(`Error changing aliases for all players in game ${gameData.gameId}: ${res.error}`);
                return;
            }
            setAlertMessage('Aliases have been changed for all players.');
            trackEvent(
                'player_aliases_reset',
                'Game Manager',
                `Aliases changed for all players in game ${gameData.gameId}.`,
                null,
                membership
            )
        }
    }

    function cancel() {
        navigate(`${location.pathname.includes('/preview/manager/')
                ? '/preview/manager'
                : '/manage'
            }/${gameData.path}`);
    }

    return (
        <div className={`player-list-container ${screenSize}`}>
            <Routes>

                <Route path='' element={
                    (gameData) &&
                    <div className='g-card players-card'>
                        <BackButton cancel={cancel} />
                        <div className="g-space-1"></div>

                        <div className='card-title players-title'>
                            <div>View Players</div>
                            <div className='button-row'>
                                {/* {
                                    (currentFilter) &&
                                    <button 
                                        className={`g-button ${
                                            screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                        }`} 
                                        title='Clear Player Info Filter' 
                                        onClick={() => clearFilter()}
                                    >
                                        <FontAwesomeIcon icon={faFilterCircleXmark} />
                                    </button>
                                } */}
                                {
                                    (manager) &&
                                    <button
                                        className={`g-button ${screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                            }`}
                                        onClick={() => checkMembership()}
                                    >
                                        Add New Players
                                    </button>
                                }
                                {/* {
                                    (screenSize !== 'mobile' && screenSize !== 'tablet') &&
                                    <button 
                                        className={`g-button ${
                                                screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                            } ${
                                                sortedPlayers.length === 0 ? 'disabled' : ''
                                            }`} 
                                        onClick={() => setShowPlayerInfo(!showPlayerInfo)}
                                    >
                                        {
                                            showPlayerInfo ? 
                                            'Hide Player Info' : 
                                            'Show Player Info'
                                        }
                                    </button>
                                } */}
                                {/* <button 
                                    className={`g-button ${
                                            screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                        } ${
                                            sortedPlayers.length === 0 ? 'disabled' : ''
                                        }`} 
                                    onClick={() => setShowAliases(!showAliases)}
                                >
                                    {showAliases ? 'Show Real Names' : 'Show Aliases'}
                                </button> */}
                                <button
                                    className={`g-button ${screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                        } ${sortedPlayers.length === 0 ? 'disabled' : ''
                                        }`}
                                    onClick={() => setShowPlayerDrop(!showPlayerDrop)}>
                                    {/* <FontAwesomeIcon icon={faEllipsisV} /> */}
                                    More...
                                </button>
                                <div className={`player-dropdown ${showPlayerDrop ? 'active' : ''} ${manager ? 'full' : ''} ${screenSize
                                    }`
                                }>
                                    {
                                        (passcodePlayers.length > 0) &&
                                        <div className={`drop-buttons ${screenSize}`}>
                                            <button
                                                className={`g-button text-only ${screenSize === 'mobile' ? 'tiny-btn' : 'small-btn'
                                                    }`}
                                                title='Print Login Information'
                                                onClick={() => {
                                                    setShowPlayerDrop(false);
                                                    printLogins()
                                                }} >
                                                <FontAwesomeIcon icon={faPrint} />
                                                Print Login Cards

                                            </button>
                                            <button
                                                className={`g-button text-only ${screenSize === 'mobile' ? 'tiny-btn' : 'small-btn'
                                                    }`}
                                                title='Print Player QR Codes'
                                                onClick={() => {
                                                    setShowPlayerDrop(false);
                                                    printQrCodes()
                                                }} >
                                                <FontAwesomeIcon icon={faQrcode} />
                                                Print Player QR Codes

                                            </button>
                                            {
                                                (manager) &&
                                                <>
                                                    <button
                                                        className={`g-button text-only disabled ${screenSize === 'mobile' ? 'tiny-btn' : 'small-btn'
                                                            }`}
                                                        onClick={() => {
                                                            setShowPlayerDrop(false);
                                                            downloadPlayerData()
                                                        }} >
                                                        <FontAwesomeIcon icon={faDownload} />
                                                        Download Player Data
                                                    </button>
                                                    <button
                                                        className={`g-button text-only disabled ${screenSize === 'mobile' ? 'tiny-btn' : 'small-btn'
                                                            }`}
                                                        onClick={() => {
                                                            setShowPlayerDrop(false);
                                                            newAliases()
                                                        }} >
                                                        <FontAwesomeIcon icon={faSignature} />
                                                        Change Aliases
                                                    </button>
                                                    <button
                                                        className={`g-button text-only disabled ${screenSize === 'mobile' ? 'tiny-btn' : 'small-btn'
                                                            }`}
                                                        title='Print Login Information'
                                                        onClick={() => {
                                                            setShowPlayerDrop(false);
                                                            navigate('reset')
                                                        }} >
                                                        <FontAwesomeIcon icon={faRefresh} />
                                                        Reset Game Data
                                                    </button>
                                                </>
                                            }
                                        </div>
                                    }
                                </div>

                                {/* <button 
                                    className="g-button med-btn" 
                                    title='Download Current Stats'
                                >
                                    <FontAwesomeIcon icon={faDownload} />
                                </button> */}
                            </div>
                        </div>
                        {/* <CsvDownload
                            /> */}
                        <div className="g-space-0-5"></div>
                        {/* <hr className='no-margin'/> */}
                        <p className='meta'>Player Count: {playerCount}/{membershipRestrictions[membership.membership].playerCount.toLocaleString()}</p>
                        <div className='g-space-0-5'></div>
                        <div className={`search-bar-container ${screenSize}`}>
                            <SearchBar
                                search={search}
                                idLabel='player-search-input' />
                            <button
                                className={`g-button filter-button ${screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                    }`}
                                onClick={() => setShowTeamsFilterModal(true)} >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className={
                                        chosenTeams.length > 0
                                            ? 'full'
                                            : 'empty'
                                    } />
                                {
                                    (
                                        screenSize === 'mobile' ||
                                        screenSize === 'tablet'
                                    )
                                        ? <FontAwesomeIcon icon={faUsers} />
                                        : 'Team'
                                }
                            </button>
                            <button
                                className={`g-button filter-button ${screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                    }`}
                                onClick={() => setShowInfoFilterModal(true)} >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className={
                                        chosenInfo.length > 0
                                            ? 'full'
                                            : 'empty'
                                    } />
                                {
                                    (
                                        screenSize === 'mobile' ||
                                        screenSize === 'tablet'
                                    )
                                        ? <FontAwesomeIcon icon={faList} />
                                        : 'Info'
                                }
                            </button>
                            <button
                                className={`g-button filter-button ${screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                                    }`}
                                title='Clear Selected Players'
                                onClick={() => deselectAll()}>
                                <FontAwesomeIcon
                                    icon={faBan}
                                />
                            </button>
                        </div>
                        <div className='g-space-1'></div>
                        {
                            (screenSize === 'largeTablet' || screenSize === 'desktop') &&
                            <PlayerListDesktop
                                gameData={gameData}
                                sortedPlayers={sortedPlayers}
                                setCurrentSort={setCurrentSort}
                                setCurrentFilter={setCurrentFilter}
                                manager={manager}
                                gameElements={gameElements}
                                viewHeight={viewHeight} />
                        }
                        {
                            (screenSize === 'mobile' || screenSize === 'tablet') &&
                            <PlayerListMobile
                                gameData={gameData}
                                sortedPlayers={sortedPlayers}
                                gameElements={gameElements}
                                showAliases={showAliases} />
                        }
                    </div>
                }
                ></Route>
                <Route
                    path=':playerPath/*'
                    element={
                        <ManagerPlayerView
                            gameData={gameData}
                            playerList={playerList}
                            gameElements={gameElements}
                            setMainAlert={setAlertMessage}
                            gameStats={gameStats}
                            passcodes={passcodes}
                            role={role}
                        />
                    }
                ></Route>
                <Route path='add' element={
                    <AddPlayer gameData={gameData} />}
                ></Route>
                <Route path='reset' element={
                    <ResetData
                        gameData={gameData} />
                }></Route>
                <Route path="*" element={<Navigate replace to="/404" />} />
            </Routes>
            <ModalAlert show={alertMessage} cancel={() => setAlertMessage(null)} message={alertMessage} />
            <ModalConfirm show={confirmMessage} cancel={() => setConfirmMessage(null)} message={confirmMessage} onApprove={approveRef.current} />
            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(false)}
                closeButton={true}
                message={showUpgradeModal}
            />
            <CategoryFilterModal
                show={showTeamsFilterModal}
                cancel={() => setShowTeamsFilterModal(false)}
                chooseCategory={chooseTeam}
                categoryList={teams}
                selectedCategories={chosenTeams}
                color='var(--primary)'
                text='Filter by Team'
            />
            <CategoryFilterModal
                show={showInfoFilterModal}
                cancel={() => setShowInfoFilterModal(false)}
                chooseCategory={chooseInfo}
                categoryList={infoList}
                selectedCategories={chosenInfo}
                color='var(--primary)'
                text='Filter by Info'
            />
        </div>
    )
}

export default PlayerListContainer